import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { toastReducer } from './toast.reducer';
import { EffectsModule } from '@ngrx/effects';
import { ToastEffects } from './toast.effects';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

@NgModule({
	declarations: [],
	imports: [
		CommonModule,
		BrowserAnimationsModule,
		StoreModule.forFeature('toasts', toastReducer),
		EffectsModule.forFeature([ToastEffects]),
	],
})
export class ToastModule {}
